import { render, staticRenderFns } from "./RankDetail.vue?vue&type=template&id=0a52d675&scoped=true&"
import script from "./RankDetail.vue?vue&type=script&lang=js&"
export * from "./RankDetail.vue?vue&type=script&lang=js&"
import style0 from "./RankDetail.vue?vue&type=style&index=0&id=0a52d675&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a52d675",
  null
  
)

export default component.exports